/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { hyphenate } from '../../utils/string';

const regularDay = (date, cadence) => {
  const isWeekend = date.day() === 0 || date.day() === 6;
  const isHoliday = false;
  const headerStyle = `day-header ${date.isSame(moment(), 'day') && 'today'}`;
  return (
    <div className="day-container">
      <div className={headerStyle}>{date.format('ddd').toUpperCase()}</div>
      <div
        className={`day ${isWeekend && 'weekend'} ${isHoliday && 'holiday'}`}
      >
        <span>{date.date()}</span>
        <br />
        <div className={cadence.status && hyphenate(cadence.status)}>
          {cadence.id ? `${cadence.short_name[0]}${cadence.id}` : ''}
        </div>
      </div>
    </div>
  );
};

const firstDay = (date, cadence) => (
  <div className="first-day">
    <div className="month">
      <div>
        {date.format('MMM')} &apos;
        {date.format('YY')}
      </div>
    </div>
    {regularDay(date, cadence)}
  </div>
);

const Day = ({ date, cadence }) => {
  const dayDate = date.date();
  return dayDate === 1 ? firstDay(date, cadence) : regularDay(date, cadence);
};

Day.propTypes = {
  date: PropTypes.object,
  cadence: PropTypes.object
};

export default Day;
